$(document).ready(function(){
    if (currentUrl.includes('carrier-tag') && $('#carrierTagList').length) {

        const table = $('#carrierTagList').DataTable({
            responsive: true,
            processing: true,
            serverSide: true,
            searching: false,
            paging: false,
            ordering: false,
            info: false,
            rowReorder: {
                selector: 'td.reorder',
                dataSrc: 'position'
            },
            columns: [
                { 
                    data: 'carrier', 
                    name: 'carrier',
                    className: 'reorder'
                },
                { 
                    data: 'carrier_type', 
                    name: 'carrier_type',
                },
                { 
                    data: 'carrier_service', 
                    name: 'carrier_service',
                },
                { 
                    data: 'carrier_package', 
                    name: 'carrier_package',
                },

                { 
                    data: 'tags', 
                    name: 'tags',
                    render: function(data, type, row) {
                        var tags = ""
                        $.each(data, (key, tag) => {
                            tags += `<span class="badge bg-secondary">${tag.name.en}</span> `
                        })

                        return tags;
                    }
                },
                { 
                    data: 'id', 
                    name: 'actions',
                    render: function(data, type, row) {
                        return `
                            <div class="mt-sm-0 mt-2 dropdown-toggle">
                                <a href="#" data-bs-toggle="dropdown" class="text-dark text-decoration-none">Actions <b class="caret"></b></a>

                                <div class="dropdown-menu">
                                    <a class="dropdown-item" href="/carriers/shipping/carrier-tag/${data}/edit" >Edit</a>
                                    <div role="separator" class="dropdown-divider"></div>
                                    <a class="dropdown-item deleteCarrierTagBtn" href="javascript:void(0)" data-id="${data}">Delete</a>
                                </div>

                            </div>
                        `;
                    }
                }
            ],
            ajax: {
                url: "/carriers/shipping/carrier-tag",
            }
        }); 

        table.on('row-reorder', function (e, diff, edit) {
            let reorderedData = [];
            let totalRows = table.rows().count();
            
            diff.forEach((change) => {

                let rowData = table.row(change.node).data();
                let newPosition =  change.newPosition + 1;
                
                reorderedData.push({
                    id: rowData.id,
                    position: newPosition
                });
            });

            if (reorderedData.length > 0) {
                $.ajax({
                    url: '/carriers/shipping/carrier-tags/reorder',
                    method: 'PUT',
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    data: { tags: reorderedData },
                    success: function(response) {
                        showNotification(
                            response.success ? 
                            'Combination priority has been updated.' : 
                            'Could not update Combination priority.', 
                            response.success ?  
                            'Updated!' :
                            'Error!'
                        );
                    },
                    error: function() {
                        showNotification('An error occurred while updating the Combination priority.', 'Error!');
                    }
                });
            }
        });
    }

    $(document).on('click', '.deleteCarrierTagBtn', function(e) {
        e.preventDefault();
        var tagId = $(this).data('id');
        
        swal({
            title: 'Are you sure?',
            text: 'Delete this Carrier tag!',
            icon: 'warning',
            buttons: {
                cancel: {
                    text: 'Cancel',
                    value: null,
                    visible: true,
                    className: 'btn btn-default',
                    closeModal: true,
                },
                confirm: {
                    text: 'Delete',
                    value: true,
                    visible: true,
                    className: 'btn btn-danger',
                    closeModal: true
                }
            }
        }).then((result) => {
            if (result) {
                // User confirmed deletion
                $.ajax({
                    headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                    method: 'delete',
                    url: `/carriers/shipping/carrier-tag/${tagId}`,
                    success: function(response) {
                        if(response.status == 'success'){
                            swal('Deleted!', response.message, 'success');
                        }else{
                            swal('Error!', 'Carrier tag Not Found', 'error');
                        }
                        setTimeout(function () {
                            location.reload();
                        }, 200);
                    },
                    error: function(error) {
                        // Handle error
                        swal('Error!', 'An error occurred while deleting the Combination.', 'error');
                    }
                });
            }
        });
    });
});
